import { ValidSortFilter } from "@/helpers/enum";
import { StockMarkets } from "@/helpers/models/stock/stocks.model";
import httpService from "@/services/http.service";
import storageService from "@/services/storage.service";
import utilService from "@/services/util.service";
import { useDebounceFn } from "@vueuse/core";
// import { debounce } from "lodash";
import { onBeforeUnmount, onMounted, ref } from "vue";

const totalListCount = ref(0);
const segmentType = ref("all");
const filterType = ref(ValidSortFilter.diversification);
const filterName = ref("common.filter.diversification");
const markets = ref<string[]>([]);
const page = ref(1);
const count = ref(50);
const totalCount = ref(0);
const isDone = ref(false);
const isUsersLoading = ref<boolean>(false);
// const isUsersTwoLoading = ref<boolean>(false);
var usersList = ref<any[]>([]);
var filterList = ref<any[]>([]);
const tradersCount = ref<number>(0);
const totalTradersCount = ref<number>(0);
const tradersCountIsSet = ref<boolean>(false);
const allCount = ref<any>({});
const keyword = ref<string>("");
const ticker = ref<string>("");
const investmentMin = ref<string>("");
const investmentMax = ref<string>("");
const followerCountMin = ref<string>("");
const followerCountMax = ref<string>("");

const loggedInUser = JSON.parse(localStorage.getItem("user")!);
const selectedTab = ref();
const isStatCountUpdated = ref(false);

const getTotalStats = ref([
  {
    title: "All",
    label: "common.filter.all",
    count: 0,
    color:
      "linear-gradient(128deg, #FFC972 0%, #FF8C69 55%, #8D45DF 100%) 0% 0% no-repeat padding-box",
    maxWidth: 0,
    content: "",
  },
  {
    title: StockMarkets.stocks,
    label: "common.common.stocks",
    count: 0,
    color: "#6600ff",
    maxWidth: 0,
    content: "",
  },
  {
    title: StockMarkets.crypto,
    label: "common.common.crypto",
    count: 0,
    color: "#FF851B",
    maxWidth: 0,
    content: "",
  },
  {
    title: StockMarkets.etf,
    label: "common.filter.etfs",
    count: 0,
    color: "#598AFF",
    maxWidth: 0,
    content: "",
  },
  {
    title: StockMarkets.Futures,
    label: "common.filter.futures",
    count: 0,
    color: "#39D3D3",
    maxWidth: 0,
    content: "",
  },
  {
    title: StockMarkets.nft,
    label: "common.filter.nfts",
    count: 0,
    color: "#FF3B3B",
    maxWidth: 0,
    content: "",
  },
  {
    title: StockMarkets.indices,
    label: "common.common.indices",
    count: 0,
    color: "#FFF01B",
    maxWidth: 0,
    content: "",
  },
  {
    title: StockMarkets.options,
    label: "common.filter.options",
    count: 0,
    color: "#FF1B9C",
    maxWidth: 0,
    content: "",
  },
]);

const firstTimeLoading = ref(false);
const newInformation = ref(false);
const CountLoadingFirstTime = ref(0);

export const DashboardComposables = (props?: any) => {
  const scrollListeners = new WeakMap();
  const onTabChange = async (tab) => {
    console.log(tab, 'tab');
    segmentType.value = tab;
    page.value = 1;
    isDone.value = false;
    usersList.value = [];
    await getData()
  };
  filterList.value = [
    {
      name: "common.common.followers",
      value: ValidSortFilter.followersCount,
    },
    {
      name: "common.common.following",
      value: ValidSortFilter.followingCount,
    },
    {
      name: "common.common.views",
      value: ValidSortFilter.viewsCount,
    },
    {
      name: "common.filter.diversification",
      value: ValidSortFilter.diversification,
    },
    // {
    //   name: "Loss",
    //   value: ValidSortFilter.loss,
    // },
    // {
    //   name: "Gains",
    //   value: ValidSortFilter.gain,
    // },
    {
      name: "common.common.investments",
      value: ValidSortFilter.investments,
    },
    {
      name: "common.common.trades",
      value: ValidSortFilter.trades,
    },
    {
      name: "common.common.top_gain",
      value: ValidSortFilter.topGain,
    },
    // {
    //   name: "Top Loss",
    //   value: ValidSortFilter.topLoss,
    // },
    {
      name: "common.common.avg_gain",
      value: ValidSortFilter.avgGain,
    },
    // {
    //   name: "Average Loss",
    //   value: ValidSortFilter.avgLoss,
    // },
    {
      name: "common.common.outreach",
      value: ValidSortFilter.outreach,
    },
  ];

  // var apiCallTimeout: any;

  const selectStats = async (data: any) => {
    if (data.title === "All") {
      markets.value = [];
    } else {
      markets.value = [data.title];
    }
    page.value = 1;
    addScrollEventListener();
    usersList.value = [];
    isDone.value = false;
    setTimeout(async () => {
      getFilteredUser();
    }, 3000);
    // apiCallTimeout = setTimeout((e: any) => {
    // }, 300);
  };

  let currentRequestController: AbortController | null = null;
  let lastRequestSignature = '';
  let isRequestInProgress = false;
  const getRequestSignature = () => {
    return JSON.stringify({
      segmentType: segmentType.value,
      filterType: filterType.value,
      markets: markets.value.join(","),
      page: page.value,
      keyword: keyword.value,
      ticker: ticker.value,
      investmentMin: investmentMin.value,
      investmentMax: investmentMax.value,
      followerCountMin: followerCountMin.value,
      followerCountMax: followerCountMax.value
    });
  };
  const shouldCancelOngoingRequest = (newSignature: string): boolean => {
    // Only cancel if:
    // 1. There's an ongoing request
    // 2. AND the new request is different (not a load more)
    // 3. AND it's not the same page load (different parameters)
    return isRequestInProgress &&
      newSignature !== lastRequestSignature &&
      !isLoadMoreRequest(newSignature);
  };
  const isLoadMoreRequest = (newSignature: string): boolean => {
    if (!lastRequestSignature) return false;

    const current = JSON.parse(newSignature);
    const last = JSON.parse(lastRequestSignature);

    // A load more request has the same parameters except page is incremented
    const isSameParams =
      current.segmentType === last.segmentType &&
      current.filterType === last.filterType &&
      current.markets === last.markets &&
      current.keyword === last.keyword &&
      current.ticker === last.ticker &&
      current.investmentMin === last.investmentMin &&
      current.investmentMax === last.investmentMax &&
      current.followerCountMin === last.followerCountMin &&
      current.followerCountMax === last.followerCountMax;

    const isNextPage = current.page === last.page + 1;

    return isSameParams && isNextPage;
  };
  const isDuplicateRequest = (newSignature: string): boolean => {
    // Only consider it a duplicate if it's exactly the same request while one is in progress
    return isRequestInProgress && newSignature === lastRequestSignature;
  };
  const cancelOngoingRequest = () => {
    console.log('Attempting to cancel ongoing request...', { currentRequestController, isRequestInProgress });
    // Only cancel if there's an actual ongoing request
    if (currentRequestController && isRequestInProgress) {
      currentRequestController.abort();
      currentRequestController = null;
      isRequestInProgress = false;
      console.log('Cancelled ongoing request');
    }
  };




  const getFilteredUser = async () => {
    const currentSignature = getRequestSignature();

    // Don't proceed if this is an exact duplicate request
    if (isDuplicateRequest(currentSignature)) {
      console.log('Exact duplicate request detected, skipping...');
      return;
    }

    if (isDone.value) return;

    // Only cancel ongoing request if it's a different type of request (not load more)
    if (shouldCancelOngoingRequest(currentSignature)) {
      cancelOngoingRequest();
    }

    isUsersLoading.value = true;
    isRequestInProgress = true;
    currentRequestController = new AbortController();
    lastRequestSignature = currentSignature;

    try {
      const query = buildQueryString();
      const token = storageService.getToken();
      const user = storageService.getUser();

      // console.log('Making API request:', {
      //   page: page.value,
      //   signature: currentSignature,
      //   isLoadMore: isLoadMoreRequest(currentSignature)
      // });
      console.log('api calling here');
      const apiCall = (!token || !user || !user._id)
        ? httpService.getPublicFilteredUser(query, { signal: currentRequestController.signal })
        : httpService.getFilteredUser(query, { signal: currentRequestController.signal });

      const response = await apiCall;

      // Check if request was cancelled before processing
      if (currentRequestController.signal.aborted) {
        console.log('Request was aborted, skipping processing');
        return;
      }

      if (firstTimeLoading.value) {
        CountLoadingFirstTime.value = response.data.data.totalCount;
        firstTimeLoading.value = false;
      }

      handleSuccessfulResponse(response);

    } catch (error: any) {
      // Only handle error if it wasn't an abort error
      if (error.name !== 'AbortError') {
        handleError(error);
      } else {
        console.log('Request was cancelled as expected');
      }
    } finally {
      // Reset loading state
      isRequestInProgress = false;
      isUsersLoading.value = false;
      currentRequestController = null;
    }
  };

  const cleanupRequest = () => {
    currentRequestController = null;
    isRequestInProgress = false;
    isUsersLoading.value = false;
  };

  // Helper functions
  const buildQueryString = () => {
    const params = new URLSearchParams({
      type: segmentType.value,
      sortFilter: filterType.value,
      page: page.value.toString(),
      count: count.value.toString(),
      market: markets.value.join(",")
    });


    const optionalParams = {
      keyword: keyword.value,
      ticker: ticker.value,
      investmentMin: investmentMin.value,
      investmentMax: investmentMax.value,
      followerCountMin: followerCountMin.value,
      followerCountMax: followerCountMax.value
    };

    Object.entries(optionalParams).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });

    return `?${params.toString()}`;
  };

  const handleSuccessfulResponse = (response: any) => {
    if (!response.data.isSuccess || !response.data.data?.list) {
      resetData();
      return;
    }
    const { data } = response.data;
    updateStatsCounts(data.diversificationCount);
    totalListCount.value += data.list.length;
    updateUsersList(data.list);
    updatePaginationData(data);

    isStatCountUpdated.value = true;
    cleanupRequest();
  };

  const updateStatsCounts = (diversificationCount: any) => {
    allCount.value = diversificationCount;

    const countMapping = {
      "All": diversificationCount.total,
      [StockMarkets.Futures]: diversificationCount.futures,
      [StockMarkets.crypto]: diversificationCount.crypto,
      [StockMarkets.etf]: diversificationCount.ETFs,
      [StockMarkets.indices]: diversificationCount.indices,
      [StockMarkets.nft]: diversificationCount.nft,
      [StockMarkets.options]: diversificationCount.options,
      [StockMarkets.stocks]: diversificationCount.stocks,
    };

    getTotalStats.value.forEach(item => {
      if (countMapping[item.title] !== undefined) {
        item.count = countMapping[item.title];
      }
    });
  };

  const updateUsersList = (newUsers: any[]) => {
    if (page.value === 1) {
      usersList.value = newUsers;
    } else {
      const existingIds = new Set(usersList.value.map(u => u._id));
      const filteredNewUsers = newUsers.filter(u => !existingIds.has(u._id));
      usersList.value = [...usersList.value, ...filteredNewUsers];
    }
  };

  const updatePaginationData = (data: any) => {
    tradersCount.value = data.totalTraders;

    if (totalTradersCount.value === 0) {
      totalTradersCount.value = data.totalTraders;
    }

    tradersCountIsSet.value = true;
    totalCount.value = data.totalCount;

    if (page.value * count.value >= totalCount.value || usersList.value.length >= totalCount.value) {
      isDone.value = true;
    } else {
      page.value += 1;
    }
  };

  const resetData = () => {
    allCount.value = {};
    totalCount.value = 0;
    usersList.value = [];
    isDone.value = false;
    isStatCountUpdated.value = true;
  };

  const handleError = (error: any) => {
    if (error.name === 'AbortError') {
      console.log('Request was cancelled');
      return;
    }

    console.log('Error fetching filtered users:', error);
    isUsersLoading.value = false;
    isStatCountUpdated.value = true;
  };

  const myAllOtherUsers = async (id: string) => {
    isUsersLoading.value = true;
    try {
      let query: any = null;
      query = `?type=${segmentType.value}&sortFilter=${filterType.value}&page=${page.value
        }&count=${count.value}&market=${markets.value.join(",")}&keyword=${keyword.value
        }`;
      httpService
        .getAllUserOfOtherUser(query, id)
        .then((response: any) => {
          isUsersLoading.value = false;
          // isUsersTwoLoading.value = false;
          if (response.data.isSuccess) {
            allCount.value = response.data.data.diversificationCount;
            for (let item of getTotalStats.value) {
              if (item.title === "All") {
                item.count = allCount.value.total;
              }
              if (item.title === StockMarkets.Futures) {
                item.count = allCount.value.futures;
              }
              if (item.title === StockMarkets.crypto) {
                item.count = allCount.value.crypto;
              }
              if (item.title === StockMarkets.etf) {
                item.count = allCount.value.ETFs;
              }
              if (item.title === StockMarkets.indices) {
                item.count = allCount.value.indices;
              }
              if (item.title === StockMarkets.nft) {
                item.count = allCount.value.nft;
              }
              if (item.title === StockMarkets.options) {
                item.count = allCount.value.options;
              }
              if (item.title === StockMarkets.stocks) {
                item.count = allCount.value.stocks;
              }
            }
            if (page.value == 1) {
              usersList.value = [];
            }
            if (usersList.value.length === 0) {
              usersList.value = response.data.data.list;
            } else {
              for (let item of response.data.data.list) {
                usersList.value.push(item);
              }
            }
            tradersCount.value = response.data.data.totalTraders;
            tradersCountIsSet.value = true
            totalCount.value = response.data.data.totalCount;
            if (page.value * count.value >= totalCount.value) {
              isDone.value = true;
            } else {
              page.value += 1;
            }
          } else {
            allCount.value = {};
            totalCount.value = 0;
            // tradersCount.value = 0;
            // usersList.value = [];
            isDone.value = false;
            // for (let item of getTotalStats.value) {
            //   if (item.title === "All") {
            //     item.count = 0;
            //   }
            //   if (item.title === StockMarkets.Futures) {
            //     item.count = 0;
            //   }
            //   if (item.title === StockMarkets.crypto) {
            //     item.count = 0;
            //   }
            //   if (item.title === StockMarkets.etf) {
            //     item.count = 0;
            //   }
            //   if (item.title === StockMarkets.indices) {
            //     item.count = 0;
            //   }
            //   if (item.title === StockMarkets.nft) {
            //     item.count = 0;
            //   }
            //   if (item.title === StockMarkets.options) {
            //     item.count = 0;
            //   }
            //   if (item.title === StockMarkets.stocks) {
            //     item.count = 0;
            //   }
            // }
          }
          isStatCountUpdated.value = true
        })
        .catch((e: any) => {
          isUsersLoading.value = false;
        });
    } catch (e) { }
  };

  const applyConnectionsResponse = (response: any) => {
    if (response.data.isSuccess) {
      allCount.value = response.data.data.diversificationCount;
      for (let item of getTotalStats.value) {
        if (item.title === "All") {
          item.count = allCount.value?.total;
        }
        if (item.title === StockMarkets.Futures) {
          item.count = allCount.value?.futures;
        }
        if (item.title === StockMarkets.crypto) {
          item.count = allCount.value?.crypto;
        }
        if (item.title === StockMarkets.etf) {
          item.count = allCount.value?.ETFs;
        }
        if (item.title === StockMarkets.indices) {
          item.count = allCount.value?.indices;
        }
        if (item.title === StockMarkets.nft) {
          item.count = allCount.value?.nft;
        }
        if (item.title === StockMarkets.options) {
          item.count = allCount.value?.options;
        }
        if (item.title === StockMarkets.stocks) {
          item.count = allCount.value?.stocks;
        }
      }
      if (page.value == 1) {
        usersList.value = [];
      }
      const list = response.data.data.list || [];
      if (usersList.value.length === 0) {
        usersList.value = list;
      } else {
        for (let item of list) {
          usersList.value.push(item);
        }
      }
      tradersCount.value = response.data.data.totalTraders;
      tradersCountIsSet.value = true;
      totalCount.value = response.data.data.totalCount;
      if (page.value * count.value >= totalCount.value) {
        isDone.value = true;
      } else {
        page.value += 1;
      }
    } else {
      allCount.value = {};
      totalCount.value = 0;
      isDone.value = false;
    }
    isStatCountUpdated.value = true;
  };

  const buildConnectionsQuery = (id: string) => {
    // Same URL shape as Followers.vue / following.composables.ts
    // /leaderboard/userFollowers/{userId}?type=follower&...
    return `${id}?type=${segmentType.value}&sortFilter=${filterType.value}&page=${page.value
      }&count=${count.value}&market=${markets.value.join(",")}&keyword=${keyword.value
      }`;
  };

  const followerOfOtherUSer = async (id: string) => {
    if (!id) return;
    isUsersLoading.value = true;
    try {
      const response = await httpService.getFollowedUser(buildConnectionsQuery(id));
      applyConnectionsResponse(response);
    } catch (e) {
      isStatCountUpdated.value = true;
    } finally {
      isUsersLoading.value = false;
    }
  };

  const followingOfOtherUSer = async (id: string) => {
    if (!id) return;
    isUsersLoading.value = true;
    try {
      const response = await httpService.getFollowingUser(buildConnectionsQuery(id));
      applyConnectionsResponse(response);
    } catch (e) {
      isStatCountUpdated.value = true;
    } finally {
      isUsersLoading.value = false;
    }
  };

  const getData = async () => {
    console.log(props);
    console.log(loggedInUser, "loggedInUser");
    let user = storageService.getUser();
    const isOwnProfile =
      props?.user?._id && user?._id && props.user._id === user._id;
    const tabName = selectedTab.value?.name || segmentType.value;

    // Followers / Following must use dedicated endpoints.
    // /leaderboard/filterUser does not return connection lists (counts come from /leaderboard/counts).
    if (tabName === "follower") {
      await followerOfOtherUSer(props?.user?._id);
      return;
    }
    if (tabName === "following") {
      await followingOfOtherUSer(props?.user?._id);
      return;
    }

    if (isOwnProfile) {
      console.log("data loading");
      await getFilteredUser();
    } else if (props?.user?._id) {
      await myAllOtherUsers(props.user._id);
    }
  };

  const debouncedGetFilteredUser = useDebounceFn(() => {
    if (!isDone.value && !isDuplicateRequest(getRequestSignature())) {
      getFilteredUser();
    }
  }, 500);

  const onScroll = () => {
    if (isDone.value) {
      removeScrollEventListener();
      return;
    }

    const frameView = document.getElementById("frame_view");
    if (frameView) {
      const { scrollTop, scrollHeight, clientHeight } = frameView;
      const bottomOffset = 500; // Increased offset

      if (scrollHeight - scrollTop <= clientHeight + bottomOffset) {
        debouncedGetFilteredUser();
      }
    }
  };

  onMounted(() => {
    addScrollEventListener();
  });

  const addScrollEventListener = () => {
    const frameView = document.getElementById("frame_view");
    if (frameView && !scrollListeners.has(frameView)) {
      const handler = useDebounceFn(onScroll, 100);
      frameView.addEventListener("scroll", handler);
      scrollListeners.set(frameView, handler);
    }
  };

  const removeScrollEventListener = () => {
    const frameView = document.getElementById("frame_view");
    if (frameView && scrollListeners.has(frameView)) {
      frameView.removeEventListener("scroll", scrollListeners.get(frameView));
      scrollListeners.delete(frameView);
    }
  };

  onBeforeUnmount(() => {
    removeScrollEventListener();
  });

  // const getDashboardFilterCountData = async () => {
  //   try {
  //     httpService
  //       .getDashboardFilterCountData()
  //       .then((response: any) => {
  //         if (response.data.isSuccess) {
  //           allCount.value = response.data.data;
  //           for (let item of getTotalStats.value) {
  //             if (item.title === "All") {
  //               item.count = allCount.value.total;
  //             }
  //             if (item.title === StockMarkets.Futures) {
  //               item.count = allCount.value.futures;
  //             }
  //             if (item.title === StockMarkets.crypto) {
  //               item.count = allCount.value.crypto;
  //             }
  //             if (item.title === StockMarkets.etf) {
  //               item.count = allCount.value.ETFs;
  //             }
  //             if (item.title === StockMarkets.indices) {
  //               item.count = allCount.value.indices;
  //             }
  //             if (item.title === StockMarkets.nft) {
  //               item.count = allCount.value.nft;
  //             }
  //             if (item.title === StockMarkets.options) {
  //               item.count = allCount.value.options;
  //             }
  //             if (item.title === StockMarkets.stocks) {
  //               item.count = allCount.value.stocks;
  //             }
  //           }
  //         } else {
  //         }
  //       })
  //       .catch((e: any) => { });
  //   } catch (e) { }
  // };

  const changingTabs = async (data: any) => {
    // clearTimeout(apiCallTimeout);
    if (data != "all" && storageService.getUser().isGuestUser) {
      utilService.showGuestUserFlow();
      return;
    }
    segmentType.value = data;
    usersList.value = [];
    // setTimeout(async () => {
    // }, 3000);
    try {
      await getData();
    } catch (e: any) {
      console.log(e);
    }
    // apiCallTimeout = setTimeout(async (e: any) => {
    // }, 300);
  };

  const selectFilter = async (data: any) => {
    // clearTimeout(apiCallTimeout);
    if (storageService.getUser().isGuestUser) {
      utilService.showGuestUserFlow();
      return;
    }
    filterType.value = data.value;
    filterName.value = data.name;
    page.value = 1;
    usersList.value = [];
    isDone.value = false;
    addScrollEventListener();
    setTimeout(async () => {
      await getData();
    }, 3000);
    // apiCallTimeout = setTimeout(async (e: any) => {
    // }, 300);
  };

  const showMore = () => {
    // page.value = page.value + 1;
    getData();
  };

  return {
    totalListCount,
    CountLoadingFirstTime,
    firstTimeLoading,
    filterList,
    selectStats,
    changingTabs,
    newInformation,
    segmentType,
    showMore,
    page,
    // getDashboardFilterCountData,
    count,
    filterName,
    selectFilter,
    isUsersLoading,
    // isUsersTwoLoading,
    markets,
    usersList,
    getFilteredUser,
    filterType,
    totalCount,
    getTotalStats,
    tradersCount,
    totalTradersCount,
    tradersCountIsSet,
    isDone,
    keyword,
    selectedTab,
    getData,
    myAllOtherUsers,
    followingOfOtherUSer,
    followerOfOtherUSer,
    isStatCountUpdated,
    onTabChange,
    ticker,
    investmentMin,
    investmentMax,
    followerCountMin,
    followerCountMax,
  };
};
